import React,{useEffect} from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Container, Button, Row, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getCounterDetail, deleteRead } from '../../../actions/countersActions'
import { getFarms } from '../../../actions/farmsActions'
import FormCounterRegister from './FormCounterRegister'
import Swal from 'sweetalert2'

export default function CounterEdit() {
    const { t } = useTranslation()
    const {id} = useParams()
    const {counter} = useSelector(state=>state.counters)
    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(getCounterDetail(id))
        dispatch(getFarms())
    }, [dispatch,id])

    const deleteReadValue = (id) => {
        dispatch(deleteRead(counter._id, id))
        Swal.fire({
            showConfirmButton: true,
            confirmButtonText: t('counters.letsok'),
            icon: 'success',
            text: t('counters.deletereadsuccessful')
        })
    }

    return (
        <Container className='cuerpo'>
            <Row className="text-left custom-card-header-list">
                <Row className="custom-card-buttom">
                    <Button className="btn btn-secondary mb-4 mx-auto" href={`/admin/counters`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('counters.volver')}
                    </Button>
                </Row>
                <Row>
                    <h1>{t('counters.name')}: <span className='text-uppercase'>{counter?.name}</span></h1>
                    <FormCounterRegister counter={counter?._id}></FormCounterRegister>
                </Row>
                <Row>
                    <Table striped bordered hover responsive size="m" className='mt-4 font-size-large'>
                        <thead>
                            <tr>
                                <td><h5>{t('counters.date')}</h5></td>
                                <td><h5>{t('counters.log')}</h5></td>
                                <td><h5>{t('counters.user')}</h5></td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            { counter?.reading?.map((datos, id) => (
                                <tr key={id}>
                                    <td>{datos.date.substr(8,2)+'/'+datos.date.substr(5,2)+'/'+datos.date.substr(0,4)+' - '+datos.date.substr(11,8)}</td>
                                    <td>{datos.quantity} {datos.type}</td>
                                    <td>{datos.user?.firstname} {datos.user?.lastname}</td>
                                    <td>
                                        <Button variant="outline-danger" onClick={() => deleteReadValue(id)}>
                                            <i className="fas fa-digital-tachograph"></i> <i className="fas fa-minus fa-sm"></i>
                                        </Button>
                                    </td>
                                </tr>
                            )) }
                        </tbody>
                    </Table>
                </Row>
            </Row>
        </Container>
    )
}
